var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#5981FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10034_12744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25V17.25H8.25V11.25H15.75ZM16.5 9.75H7.5C7.0875 9.75 6.75 10.0875 6.75 10.5V18C6.75 18.4125 7.0875 18.75 7.5 18.75H16.5C16.9125 18.75 17.25 18.4125 17.25 18V15.375L20.25 18.375V10.125L17.25 13.125V10.5C17.25 10.0875 16.9125 9.75 16.5 9.75Z",
    fill: "#F6F8FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10034_12744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.5 5.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetIcon);
export default __webpack_public_path__ + "static/media/MeetIcon.93b538d5fbf5a1438203f28758eeae37.svg";
export { ForwardRef as ReactComponent };